// Catalog navigation paths.
//
// Centralised so the Home dashboard's catalog card — both the title and the
// "View" CTA (PLO-4408) — route to the same catalog detail page and can't
// silently diverge. Matches the `/members/access/catalogs/:id` route defined in
// Members/index.tsx.
export const catalogDetailPath = (catalogId: string): string =>
  `/members/access/catalogs/${catalogId}`;
